module.exports = __webpack_public_path__ + "img/estp.7953189d.png";